
import { defineComponent } from "vue";
import Hero from "@/components/Hero.vue";
import Button from "@/components/Button.vue";
import HeroFestivalSlogan from "@/components/hero/HeroFestivalSlogan.vue";

export default defineComponent({
  components: {
    Hero,
    Button,
    HeroFestivalSlogan,
  },
});
